import { render, staticRenderFns } from "./editFieldsModal.vue?vue&type=template&id=64a9f988&scoped=true&"
import script from "./editFieldsModal.vue?vue&type=script&lang=js&"
export * from "./editFieldsModal.vue?vue&type=script&lang=js&"
import style0 from "./editFieldsModal.vue?vue&type=style&index=0&id=64a9f988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a9f988",
  null
  
)

export default component.exports